import { Link } from 'react-router-dom';
import React from 'react';

const Breadcrumb = (props) => {
  return (
    <nav className="" aria-label="breadcrumb">
      <ol className="breadcrumb">
        {props.navigation.map((navigation, index) => {
          return (
            <li key={index} className="breadcrumb-item">
              <Link to={navigation.link}>{navigation.title}</Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
